import React from "react";
import Rating from "@mui/material/Rating";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import Tooltip from "@mui/material/Tooltip";
import { RATING_LABELS } from "./helpers";

/* One row of the review: the KRA, how it is measured, the stars and a note. */
const RatingInput = ({ value, onChange, readOnly, label = "rating" }) => (
    <span className="wh-rating perf-rating">
        <Tooltip title={RATING_LABELS[value] || "Not rated"} placement="top" arrow>
            <span>
                <Rating
                    name={label}
                    value={Number(value) || 0}
                    readOnly={readOnly}
                    size="medium"
                    icon={<StarRoundedIcon fontSize="inherit" />}
                    emptyIcon={<StarRoundedIcon style={{ opacity: 1 }} fontSize="inherit" />}
                    onChange={(e, next) => onChange && onChange(next || 0)}
                />
            </span>
        </Tooltip>
        <b>{value ? `${value}/5` : "--"}</b>
    </span>
);

export default RatingInput;
